// Wires every .stp-hindi-toggle button on the page (there's normally
// just one, in the header, but this is safe if it's ever rendered
// twice). Unlike the dark-mode toggle this doesn't flip a client-side
// attribute -- it sets Shopify's real locale_code hidden input and
// submits the localization form, which is a real page navigation:
// Shopify sets the locale cookie server-side and re-renders the whole
// page (and every page after, until toggled back) in the chosen
// language via its native translations.
(function () {
  function toggle(event) {
    var btn = event.currentTarget;
    var form = btn.closest('form');
    var input = form.querySelector('input[name="locale_code"]');
    if (!input) return;
    var switchingToHindi = btn.getAttribute('aria-pressed') !== 'true';
    input.value = switchingToHindi ? 'hi' : 'en';
    form.submit();
  }

  document.querySelectorAll('.stp-hindi-toggle').forEach(function (btn) {
    btn.addEventListener('click', toggle);
  });
})();
